// extracted by mini-css-extract-plugin
export default {"highlightText":"FlightCardHighlight-module__highlightText___k0Fb4"};